export default "__VITE_ASSET__CkVXaf7$__"